import React, { Fragment } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Col, Container } from 'reactstrap'
import { H3,P ,Btn } from '../../../AbstractElements'
import { BACK_TO_HOME_PAGE, ErrorPageContent, Pagenotfound, retry } from '../../../Constant'
import { Error5 } from '../../../Data/Page/Svg'

const Error_page5 = () => {
  const navigate = useNavigate()
  const handleClick = () => {
    navigate('/dashboard/default');
  }
  const handleClickBack = () => {
    navigate(-1);
  }
  return (
    <Fragment>
       <div className='page-wrapper compact-wrapper' id='pageWrapper'>
          <div className='error-wrapper'>
            <Container>
              <div className='svg-wrapper error5'>
                <Error5/>
              </div>
              <Col md="8" className="offset-md-2">
                  <H3>{Pagenotfound}</H3>
                   <div className='d-flex justify-content-center align-items-center gap-1 mt-3'>
                  <button onClick={handleClick} className='btn btn-primary btn-sm px-3'>{BACK_TO_HOME_PAGE}</button>
                  <button onClick={handleClickBack} className='btn btn-outline-primary btn-sm px-3'>{retry}</button>
                </div>
                </Col>
            </Container>
          </div>
      </div>  
    </Fragment>
  )
}

export default Error_page5